export default __webpack_public_path__ + "5311d4c9280f0465016266318da5676b.png";